{
  "Accessibility Menu": "Menú d'accessibilitat",
  "Reset settings": "Restablir configuració",
  "Close": "Tancar",
  "Content Adjustments": "Ajustos de contingut",
  "Adjust Font Size": "Ajustar la mida de la font",
  "Highlight Title": "Destacar títol",
  "Highlight Links": "Destacar enllaços",
  "Readable Font": "Font llegible",
  "Color Adjustments": "Ajustos de color",
  "Dark Contrast": "Contrast fosc",
  "Light Contrast": "Contrast clar",
  "High Contrast": "Alt contrast",
  "High Saturation": "Alta saturació",
  "Low Saturation": "Baixa saturació",
  "Monochrome": "Monocrom",
  "Contrast": "Contrast",
  "Invert Colors": "Inverteix els colors",
  "Tools": "Eines",
  "Reading Guide": "Guia de lectura",
  "Stop Animations": "Aturar animacions",
  "Big Cursor": "Cursor gran",
  "Increase Font Size": "Augmentar mida de la font",
  "Decrease Font Size": "Reduir mida de la font",
  "Letter Spacing": "Espaiat entre lletres",
  "Line Height": "Alçada de línia",
  "Font Weight": "Gruix de la font",
  "Dyslexia Font": "Font per a dislèxia",
  "Language": "Idioma",
  "Open Accessibility Menu": "Obrir menú d'accessibilitat",
  "Widget Settings": "Configuració del giny",
  "Widget Position": "Posició del giny",
  "Top Left": "Part superior esquerra",
  "Top Center": "Part superior central",
  "Top Right": "Part superior dreta",
  "Center Left": "Centre esquerra",
  "Center Right": "Centre dreta",
  "Bottom Left": "Part inferior esquerra",
  "Bottom Center": "Part inferior central",
  "Bottom Right": "Part inferior dreta",
  "Screen Reader": "Lectura de pantalla",
  "Voice Navigation": "Navegació per veu",
  "Custom Color": "Color personalitzat",
  "Change the site's colors": "Canvia els colors del lloc",
  "Backgrounds": "Fons",
  "Headings": "Encapçalaments",
  "Contents": "Continguts",
  "Reset colors": "Restableix els colors",
  "Image Desaturation": "Dessaturació d’imatges",
  "Search languages": "Cerca idiomes",
  "No languages found": "No s'han trobat idiomes",
  "Accessibility Profiles": "Perfils d'accessibilitat",
  "Motor Impaired": "Discapacitat motriu",
  "Big cursor, voice navigation, and no animations.": "Cursor gran, navegació per veu i sense animacions.",
  "Blind": "Ceguesa",
  "Screen reader helpers with higher contrast.": "Ajuts per a lectors de pantalla amb més contrast.",
  "Color Blind": "Daltonisme",
  "High contrast palette with desaturated media.": "Paleta d'alt contrast amb mèdia dessaturada.",
  "Dyslexia": "Dislèxia",
  "Friendly font, extra spacing, stronger weight.": "Tipus de lletra amigable, més espaiat i major gruix.",
  "Low vision": "Baixa visió",
  "Dark contrast and 130% magnification.": "Contrast fosc i ampliació del 130 %.",
  "Cognitive & Learning": "Cognitiu i aprenentatge",
  "Highlights key sections and enables voice help.": "Destaca les seccions clau i activa l'ajuda per veu.",
  "Seizure & Epileptic": "Convulsions i epilèpsia",
  "Stops animations and desaturates imagery.": "Atura animacions i dessatura les imatges.",
  "ADHD": "TDAH",
  "Reading guide, highlighted links, calmer palette.": "Guia de lectura, enllaços ressaltats i paleta més calmada.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
